import React from "react";
import MainPage from "./components/MainPage/MainPage";
import "./assets/scss/reset.scss"
import "./assets/scss/media.scss"
import "./App.scss"


function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
}

export default App;
